/* Card option chooser: one labelled row per option, so a bundle shows which product each choice is for
   (e.g. "Choose trunk organizer size" then "Choose sunglasses holder color"). */
(() => {
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const state = new WeakMap();

  const fits = (st, v, skip) => st.chosen.every((c, j) => j === skip || c == null || v.o[j] === c);

  const render = (qa) => {
    const st = state.get(qa);
    const box = qa.querySelector('.am-pick');
    const next = st.chosen.findIndex((c) => c == null);
    box.innerHTML = st.names.map((name, i) => {
      const values = [...new Set(st.variants.map((v) => v.o[i]))];
      const buttons = values.map((val) => {
        const ok = st.variants.some((v) => v.a && v.o[i] === val && fits(st, v, i));
        const on = st.chosen[i] === val;
        return `<button type="button" data-am-pick-opt="${i}" data-val="${esc(val)}" aria-pressed="${on}"${ok ? '' : ' disabled'}>${esc(val)}</button>`;
      }).join('');
      return `<div class="am-pick__group${i === next ? ' is-next' : ''}${st.chosen[i] != null ? ' is-done' : ''}" role="group" aria-label="Choose ${esc(name)}">` +
        `<span class="am-pick__label">Choose ${esc(name.toLowerCase())}</span>` +
        `<div class="am-pick__opts">${buttons}</div></div>`;
    }).join('');
  };

  const addChosen = (qa) => {
    const st = state.get(qa);
    const v = st.variants.find((x) => x.a && x.o.every((o, j) => o === st.chosen[j]));
    if (!v) return false;
    qa.dataset.amQa = v.id;
    qa.dataset.amPicked = '1';
    qa.classList.remove('is-picking');
    qa.querySelector('[data-am-qa-add]').click();
    return true;
  };

  const open = (qa) => {
    let names, variants;
    try {
      names = JSON.parse(qa.dataset.amOptions || '[]');
      variants = JSON.parse(qa.dataset.amVariants || '[]');
    } catch (err) {
      return false;
    }
    if (!names.length || !variants.every((v) => Array.isArray(v.o))) return false;
    // Options with a single value are chosen already
    const chosen = names.map((_, i) => {
      const values = [...new Set(variants.map((v) => v.o[i]))];
      return values.length === 1 ? values[0] : null;
    });
    state.set(qa, { names, variants, chosen });
    if (chosen.every((c) => c != null) && addChosen(qa)) return true;
    document.querySelectorAll('.am-card.is-picking').forEach((c) => c !== qa && c.classList.remove('is-picking'));
    render(qa);
    qa.classList.add('is-picking');
    return true;
  };

  // Runs before the main theme script, which keeps handling everything else
  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-am-qa-add]');
    if (add) {
      const qa = add.closest('[data-am-qa]');
      if (!qa || !qa.dataset.amVariants || qa.dataset.amPicked) return;
      if (open(qa)) e.stopPropagation();
      return;
    }
    const opt = e.target.closest('[data-am-pick-opt]');
    if (!opt) return;
    e.stopPropagation();
    const qa = opt.closest('[data-am-qa]');
    const st = state.get(qa);
    if (!st) return;
    const i = Number(opt.dataset.amPickOpt);
    st.chosen[i] = st.chosen[i] === opt.dataset.val ? null : opt.dataset.val;
    // Drop later choices that no longer have stock with this one
    st.chosen.forEach((c, j) => {
      if (j !== i && c != null && !st.variants.some((v) => v.a && v.o[j] === c && fits(st, v, j))) st.chosen[j] = null;
    });
    if (st.chosen.every((c) => c != null) && addChosen(qa)) return;
    render(qa);
  }, true);
})();
